import React, { useEffect, useState } from "react";
import gamesData from "./gamesData";
import { t } from "../i18n";
import styles from "./TrendingGames.module.css";
import { useNavigate } from "react-router-dom";

const TrendingGames = () => {
  const [trendingGames, setTrendingGames] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 750);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 750);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchTrending = async () => {
      const token = sessionStorage.getItem("token");

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_PATH}/group-members?take=1000`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch group members");

        const data = await response.json();
        const members = data[0] || [];

        const groupCounts = {};
        members.forEach((member) => {
          groupCounts[member.groupID] = (groupCounts[member.groupID] || 0) + 1;
        });

        const sortedGroups = Object.entries(groupCounts)
          .sort(([, a], [, b]) => b - a)
          .map(([groupID]) => parseInt(groupID));

        const gamesWithGroup = Object.entries(gamesData)
          .filter(([_, game]) => sortedGroups.includes(game.groupId))
          .map(([name, game]) => ({ name, ...game }));

        const sortedGames = sortedGroups
          .map((id) => gamesWithGroup.find((game) => game.groupId === id))
          .filter(Boolean)
          .slice(0, 5);

        setTrendingGames(sortedGames);
      } catch (err) {
        console.error("Error loading trending games:", err);
      }
    };

    fetchTrending();
    const interval = setInterval(fetchTrending, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleGoToPage = (game) => {
    navigate(`/game/${encodeURIComponent(game.name)}`, { state: { game } });
  };

  return (
    <div className={isMobile ? styles.mobileTrendingGames : styles.trendingGamesContainer}>
      <div className={styles.trendingGamesHeader}>{t("trending_games")}</div>
      <div className={isMobile ? styles.trendingGamesScroll : styles.trendingGamesContent}>
        {trendingGames.map((game, index) => (
          <div
            key={index}
            className={styles.trendingGameItem}
            onClick={() => handleGoToPage(game)}
            style={{ cursor: "pointer" }}
          >
            <img src={game.carouselImage} alt={game.name} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrendingGames;